import { fetchPatientCareOrderHistory } from "actions/rd2RefactorActions";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

export const loadPatientCareOrderHistory = async (
    dispatch: any,
    referenceId: any,
    setIsPatientCareOrderHistoryLoading: Function,
    isMounted: () => boolean // Add a parameter to check if the component is still mounted
) => {
    try {
        setIsPatientCareOrderHistoryLoading(true);
        await dispatch(fetchPatientCareOrderHistory(referenceId));
    } finally {
        if (isMounted()) {
            setIsPatientCareOrderHistoryLoading(false);
        }
    }
};

const useLoadPatientCareOrderHistory = (
    referenceId: string,
    shouldLoad: boolean,
    setIsPatientCareOrderHistoryLoading: Function
) => {

    const dispatch = useDispatch();
    const mountedRef = useRef(true); // Use a ref to track the mounted status so we don't do
    // something like setIsPatientAppointmentHistoryLoading(false) on an unmounted component
    // aka it was loading in the background and no component cares if its done loading

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        // This function checks if the component is still mounted
        const isMounted = () => mountedRef.current;

        if (!shouldLoad) {
            return;
        }

        loadPatientCareOrderHistory(dispatch, referenceId, setIsPatientCareOrderHistoryLoading, isMounted);

    }, [referenceId, shouldLoad, dispatch, setIsPatientCareOrderHistoryLoading]);


};

export default useLoadPatientCareOrderHistory;